import React, { FunctionComponent } from "react";
import NextLink from "@adjust/website/src/components/NextLink";
import { Nav } from "react-bootstrap";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

type NavHeaderLinkProps = {
  name: string;
  icon: IconDefinition;
  href: string;
};

const NavHeaderLinkComponent: FunctionComponent<NavHeaderLinkProps> = ({ name, href }) => {
  return (
    <NextLink href={href}>
      <Nav.Link>
        <span className="px-1 my-auto">{name}</span>
      </Nav.Link>
    </NextLink>
  );
};

export default React.memo(NavHeaderLinkComponent);
